<template>
  <div class="intercom-modal" v-if="visible">
    <div class="modal-overlay" @click="closeModal"></div>
    <div class="modal-container">
      <div class="modal-header">
        <div class="header-title">
          <svg-icon name="voice" class="header-icon" />
          <span>{{ $translate('voiceIntercomTitle') }}</span>
        </div>
        <div class="close-btn" @click="closeModal" :title="$translate('close')">
          <svg-icon name="close" class="close-icon" />
        </div>
      </div>
      
      <div class="modal-content">
        <!-- 使用 CallPanel 组件 -->
        <CallPanel
          :user="robotInfo"
          :selectedRobot="!!robotInfo.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CallPanel from '@/view/voice/intercom/CallPanel.vue'

export default {
  name: 'IntercomModal',
  components: {
    CallPanel
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    robotInfo: {
      type: Object,
      required: true,
      default: () => ({
        id: null,
        name: '',
        serialNumber: '',
        avatar: ''
      })
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.intercom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
}

.modal-container {
  position: relative;
  width: 700px;
  max-width: 90vw;
  height: 700px;
  max-height: 85vh;
  background: linear-gradient(135deg,
    rgba(10, 25, 47, 0.98) 0%,
    rgba(10, 30, 60, 0.98) 100%
  );
  border-radius: 20px;
  border: 2px solid rgba(0, 191, 255, 0.4);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.5),
    0 0 40px rgba(0, 191, 255, 0.3),
    inset 0 0 30px rgba(0, 191, 255, 0.1);
  backdrop-filter: blur(20px);
  overflow: hidden;
  animation: modalShow 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
}

@keyframes modalShow {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-30px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: linear-gradient(
    to bottom,
    rgba(0, 191, 255, 0.15),
    transparent
  );
  border-bottom: 1px solid rgba(0, 191, 255, 0.3);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(0, 191, 255, 0.8),
      transparent
    );
  }
  
  .header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    
    .header-icon {
      font-size: 24px;
      color: rgba(0, 191, 255, 0.9);
      filter: drop-shadow(0 0 8px rgba(0, 191, 255, 0.6));
    }
    
    span {
      font-size: 22px;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 0 2px 10px rgba(0, 191, 255, 0.6);
      letter-spacing: 1px;
    }
  }
  
  .close-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0;
      height: 0;
      background: rgba(0, 191, 255, 0.3);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      transition: all 0.3s ease;
    }
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(0, 191, 255, 0.6);
      transform: scale(1.1) rotate(90deg);
      box-shadow: 0 0 15px rgba(0, 191, 255, 0.5);
      
      &::before {
        width: 100%;
        height: 100%;
      }
    }
    
    .close-icon {
      font-size: 25px;
      color: rgba(255, 255, 255, 0.9);
      position: relative;
      z-index: 1;
    }
  }
}

.modal-content {
  flex: 1;
  padding: 20px;
  overflow: hidden;
  position: relative;
  
  // 添加科技感背景装饰
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
      radial-gradient(circle at 20% 30%, rgba(0, 191, 255, 0.05), transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(0, 191, 255, 0.05), transparent 50%);
    pointer-events: none;
  }
  
  // 让 CallPanel 充满整个区域
  /deep/ .call-panel {
    height: 100%;
    border-radius: 10px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .modal-container {
    width: 95vw;
    height: 90vh;
  }
  
  .modal-header {
    padding: 16px 20px;
    
    .header-title {
      span {
        font-size: 18px;
      }
      
      .header-icon {
        font-size: 20px;
      }
    }
  }
  
  .modal-content {
    padding: 15px;
  }
}
</style>
